module.exports = __webpack_public_path__ + "static/nyc-537d2eec2d3f0bfc1dbff487dba72e77.svg";